import type { PbVideo } from '../../types/pbBlocks';
import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import { getAdvanced, getBorder, getPadding, parseStyleString } from '../utils';

export type VideoType = ContentTypeObject & PbVideo;

/**
 * Aggregates the configuration of a video element.
 * @param node
 */
export function videoConfigAggregator(node: CustomHtmlElement): VideoType {
    const inner = node.childNodes[0] as unknown as CustomHtmlElement | null;
    const wrapper = inner?.childNodes[0] as unknown as CustomHtmlElement | null;
    const video = wrapper?.childNodes[0].childNodes[0] as unknown as CustomHtmlElement | null;

    const style = parseStyleString(node?.attributes.style);
    const innerStyle = parseStyleString(inner?.attributes.style);
    const wrapperStyle = parseStyleString(wrapper?.attributes.style);

    const isAutoplayEnabled = Boolean(video && video.attributes['autoplay'] === 'true');
    const isMuted = Boolean(video && video.attributes['muted'] === 'true');

    const url = video && video.attributes['src'];

    return {
        ...getAdvanced(node, style),
        ...getBorder(wrapperStyle),
        ...getPadding(wrapperStyle),
        autoplay: isAutoplayEnabled,
        muted: isMuted,
        uniqueID: node.attributes['data-pb-style'],
        videoUrl: url ?? '',
        maxWidth: innerStyle?.maxWidth,
    };
}
